/**
* RelytArt
*
* Creative Commons Attribution-NonCommercial-NoDerivatives 4.0 International
* Copyright (c) 2022 RelytArt
*
* License: https://docs.google.com/document/d/1UD7jhCYWRXSxhx4A5vMeGVTjujwLM39BmvjwA0eFFfk/edit?usp=sharing
*
*/

// constants
const BACKGROUND_DEFAULT = "bg-white";
const CLASSNAME_DEFAULT = "bg-white spinner-border kit-border-shadow";
const MARGIN_DEFAULT = "m-auto";
const SIZE_DEFAULT = "2rem";
const TEXT_DEFAULT = "text-primary";

const LoadingSpinner = (props) => {
  // @props: background - String
  // @props: margin - String
  // @props: size - String
  // @props: text - String

  const className = (
    `${props.background || BACKGROUND_DEFAULT} ` +
    `${props.className || CLASSNAME_DEFAULT} ` +
    `${props.margin || MARGIN_DEFAULT} ` +
    `${props.text || TEXT_DEFAULT} ` +
    `${props.append || ""}`
  );

  const size = props.size || SIZE_DEFAULT;

  const propsOverride = {
    ...props,
    className: props.className || className,
    style: { height: size, width: size, ...props.style }
  };

  return (<div {...propsOverride}/>);
};
export default LoadingSpinner;
